// we don't do any error checking on props, we assume the caller has done that already
// color (string), width (number of pixels), and height (number of pixels) should always be specified
const Icon = (props) => (
	<svg
		width={props.width}
		height={props.height}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path d="M6 3H18L23 10L12 21L1 10L6 3Z" fill={props.color} />
	</svg>
);

export default Icon;
